import { Controller } from "@hotwired/stimulus"
import { install, uninstall } from "@github/hotkey"
import { isHTMLElement } from "~/types/types.util"

// Connects to data-controller="hotkey"
export default class extends Controller<HTMLBodyElement> {
  private observer?: MutationObserver

  connect() {
    // Initialize hotkeys on the current elements of the body
    this.#installHotkeys(this.element)

    // Observe any new elements that are added to the body element and install hotkeys on them
    this.observer = new MutationObserver(this.#handleNewElements.bind(this))
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    const nodes = this.element.querySelectorAll<HTMLElement>("[data-hotkey]")
    nodes.forEach((node) => uninstall(node))
    this.observer?.disconnect()
  }

  #handleNewElements(mutations: MutationRecord[]) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (isHTMLElement(node)) {
          this.#installHotkeys(node)
        }
      })
    })
  }

  #installHotkeys(node: HTMLElement) {
    const nodes: HTMLElement[] = []

    // Include the node itself if it has a data-hotkey
    if (node.dataset.hotkey) nodes.push(node)

    // Add all descendant elements with data-hotkey
    nodes.push(...Array.from(node.querySelectorAll<HTMLElement>("[data-hotkey]")))

    // Install all the hotkeys
    nodes.forEach((el) => install(el))
  }
}
